import { render, staticRenderFns } from "./SignCardList.vue?vue&type=template&id=12c53f06"
import script from "./SignCardList.vue?vue&type=script&lang=js"
export * from "./SignCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports